import { UseQueryResult } from "@tanstack/react-query";

export function combineQuery<T>(
  results: UseQueryResult[]
): Partial<UseQueryResult<T>> {
  const hasData = results.some(({ data }) => data);
  const mappedData = results.map(({ data }) => data).filter((value) => !!value);

  return {
    data: hasData ? (mappedData as T) : undefined,
    isPending: results.some((result) => result.isPending),
    isError: results.some(({ isError }) => isError),
    error: results.find(({ error }) => error)
  } as Partial<UseQueryResult<T>>;
}
